import { render, staticRenderFns } from "./OtherVehicleModalSingle.vue?vue&type=template&id=689f44c9"
import script from "./OtherVehicleModalSingle.vue?vue&type=script&lang=js"
export * from "./OtherVehicleModalSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports